import Vue from 'vue';
import App from './App';
import {router} from './router';
import store from './store'

// import store from './store/'
// import { VueAxios } from './utils/request'
// import './core/use'
// 引入全部样式
import 'vant/lib/index.less';
// 引入单个组件样式
import 'vant/lib/button/style/less';
import wx from 'weixin-js-sdk'
import bootstrap from './core/bootstrap'
import './core/lazy_use'
import './utils/filter' // global filter
import thor from 'thor-x'
import 'thor-x/dist/index.css'
import {Image as VanImage} from 'vant';
import {Row, Col, Icon, Lazyload, Empty, NavBar, Field, ImagePreview,Skeleton} from 'vant';
import {postAction} from '@/api/manage';
import md5 from 'js-md5';

Vue.prototype.$md5 = md5;

Vue.use(Lazyload, {
    lazyComponent: true
});

Vue.use(thor)
Vue.use(Row)
Vue.use(Field)
Vue.use(Col)
Vue.use(NavBar)
Vue.use(Icon)
Vue.use(Empty)
Vue.use(VanImage)
Vue.use(ImagePreview)
Vue.use(Skeleton)
import {ACCESS_TOKEN} from '@/store/mutation-types'
// Vue.ls.set(ACCESS_TOKEN,'1305607940568387584')
store.dispatch('GetInit').then(res => {
    console.log(res)
})

function getUrlParams(params) {
    var urlObj = {};
    if (!window.location.search) {
        return false;
    }
    var urlParams = window.location.search.substring(1);
    var urlArr = urlParams.split('&');
    for (var i = 0; i < urlArr.length; i++) {
        var urlArrItem = urlArr[i].split('=');
        urlObj[urlArrItem[0]] = urlArrItem[1]
    }
    // 判断是否有参数
    if (arguments.length >= 1) {
        return urlObj[params]
    }
    return urlObj;
}

router.afterEach((to, from) => {
    console.log(from);
    let _url = window.location.origin + to.fullPath
    // 非ios设备，切换路由时候进行重新签名
    // if (window.__wxjs_is_wkwebview !== true) {
        let oilId = "";
        if (window.location.href.indexOf("oilInfo")) {
            oilId = getUrlParams('id');
        }
        postAction('/web/api/auth/getJSAPI?url=' + encodeURIComponent(_url) + "&oilId=" + oilId).then(function (_lists) {
            console.log(_lists);
            // 注入配置
            wx.config({
                debug: false,
                appId: _lists.result.data.appId,
                timestamp: _lists.result.data.timestamp,
                nonceStr: _lists.result.data.nonceStr,
                signature: _lists.result.data.signature,
                jsApiList: ['chooseImage', 'getLocation', 'uploadImage', 'previewImage', 'updateTimelineShareData', 'updateAppMessageShareData','onMenuShareAppMessage','onMenuShareTimeline', 'onMenuShareTimeline', 'chooseWXPay'
                ]
            })
        })
    // }
    // 微信分享配置
    wx.ready(function () {
        // wx.onMenuShareTimeline({})
        // wx.onMenuShareAppMessage({})
    })
})

// ios 设备进入页面则进行js-sdk签名
// if (window.__wxjs_is_wkwebview === true) {
//     alert(1)
//     let _url = window.location.href.split('#')[0]
//     let oilId = "";
//     if (window.location.href.indexOf("oilInfo")) {
//         oilId = getUrlParams('id');
//     }
//     postAction('/web/api/auth/getJSAPI?url=' + encodeURIComponent(_url) + "&oilId=" + oilId).then(function (res) {
//         let _lists = res
//         wx.config({
//             debug: true,
//             appId: _lists.result.data.appId,
//             timestamp: _lists.result.data.timestamp,
//             nonceStr: _lists.result.data.nonceStr,
//             signature: _lists.result.data.signature,
//             jsApiList: ['chooseImage', 'getLocation', 'uploadImage', 'previewImage', 'updateTimelineShareData', 'updateAppMessageShareData', 'onMenuShareTimeline', 'chooseWXPay']
//         })
//     })
// }

new Vue({
    router,
    store,
    created: bootstrap,
    render: h => h(App)
}).$mount('#app')
